import {
  allPass,
  any,
  chain,
  complement,
  equals,
  filter,
  flip,
  map,
  pipe,
} from "ramda";
import { of } from "most";
import { combineEpics, withState } from "redux-most";
import { recoverWith } from "common/mostCurried";
import * as steps from "common/steps";
import * as introActions from "intro/introActions";
import * as basicDetailsActions from "basic-details/basicDetailsActions";
import * as applicationActions from "application/applicationActions";
import * as submissionActions from "submission/submissionActions";
import {
  getCountryCode,
  getStepFields,
  isCountriesEmpty,
  isCountryEmpty,
  isLibrariesEmpty,
  isStepCompleted,
} from "common/selectors";
import {
  createSyncLocalStorageEpic,
  createLoadLocalStorageEpic,
  createCompleteStepEpic,
  createAcknowledgeSubmissionEpic,
} from "common/stepEpicCommon";
import { fetchLibraries } from "common/authAjax";
import { fetchCountries, fetchSubdivisions } from "common/stipAjax";

const isStepInitAction = action =>
  action.type === submissionActions.LOCAL_STORAGE_LOADED ||
  action.type === submissionActions.SET_ACTIVE_STEP;

const loadCountriesFilter = ([state, action]) =>
  isStepInitAction(action) &&
  allPass([isCountriesEmpty])(state);

export const loadCountriesEpic = pipe(
  flip(withState),
  filter(loadCountriesFilter),
  chain(
    pipe(
      fetchCountries,
      map(basicDetailsActions.countriesLoaded),
      recoverWith(pipe(applicationActions.appError, of)),
    ),
  ),
);

const loadLibrariesFilter = ([state, action]) =>
  isStepInitAction(action) &&
  allPass([isLibrariesEmpty])(state);

export const loadLibrariesEpic = pipe(
  flip(withState),
  filter(loadLibrariesFilter),
  chain(
    pipe(
      fetchLibraries,
      map(basicDetailsActions.librariesLoaded),
      recoverWith(pipe(applicationActions.appError, of)),
    ),
  ),
);

const loadSubdivisionsFilter = ([state, action]) =>
  any(equals(action.type), [
      submissionActions.SET_ACTIVE_STEP,
      basicDetailsActions.LOCAL_STORAGE_LOADED,
      basicDetailsActions.COUNTRY_CHANGED,
      introActions.COUNTRY_CHANGED,
  ]) &&
  allPass([complement(isCountryEmpty)])(
    state,
  );

export const loadSubdivisionsEpic = pipe(
  flip(withState),
  filter(loadSubdivisionsFilter),
  chain(
    pipe(
      ([state, action]) => fetchSubdivisions(getCountryCode(state)),
      map(basicDetailsActions.subdivisionsLoaded),
      recoverWith(pipe(applicationActions.appError, of)),
    ),
  ),
);

const syncLocalStorageEpic = createSyncLocalStorageEpic(
  [
      submissionActions.CANCEL_SUBMISSION,
      submissionActions.SUBMIT,
      basicDetailsActions.COMPLETE_STEP,
      basicDetailsActions.COUNTRY_CHANGED,
      basicDetailsActions.FIELD_CHANGED,
      basicDetailsActions.LOCAL_LIBRARY_CHANGED,
      basicDetailsActions.REGION_CHANGED,
      basicDetailsActions.SET_SHOW_LOCAL_LIBRARY_OTHER,
      introActions.SUBMITTER_IS_CONTRIBUTOR_CHANGED,
  ],
  {
    completed: isStepCompleted(steps.BASIC_DETAILS),
    fields: getStepFields(steps.BASIC_DETAILS),
  },
    basicDetailsActions.localStorageSynced,
  steps.BASIC_DETAILS,
);

export default combineEpics([
    createAcknowledgeSubmissionEpic(steps.BASIC_DETAILS),
    createCompleteStepEpic(
        basicDetailsActions.COMPLETE_STEP,
        steps.BASIC_DETAILS,
    ),
    createLoadLocalStorageEpic(
      steps.BASIC_DETAILS,
      basicDetailsActions.localStorageLoaded,
    ),
    loadCountriesEpic,
    loadLibrariesEpic,
    loadSubdivisionsEpic,
    syncLocalStorageEpic,
]);
